import { iniciarPopupAlertas } from '@/helpers/popup.js';

// Plugin global para notificaciones nativas
const NotificationsPlugin = {
  install(Vue, options = {}) {
    let popupManager = null;
    
    // Método para inicializar el sistema de notificaciones
    const initNotifications = (store) => {
      if (!popupManager) {
        popupManager = iniciarPopupAlertas(store);
      }
      return popupManager;
    };

    // Métodos globales disponibles en cualquier componente
    Vue.prototype.$notifications = {
      // Inicializar sistema de notificaciones
      init(store) {
        return initNotifications(store);
      },

      // Mostrar notificación nativa simple
      show(titulo, opciones = {}) {
        if (!popupManager) {
          console.warn('⚠️ Sistema de notificaciones no inicializado. Usa $notifications.init(store) primero.');
          return null;
        }
        
        return popupManager.notificacionNativa.mostrar(titulo, opciones);
      },

      // Solicitar permisos manualmente
      async requestPermissions() {
        if (!popupManager) {
          console.warn('⚠️ Sistema de notificaciones no inicializado.');
          return false;
        }
        
        return await popupManager.habilitarNotificaciones();
      },

      // Verificar si tiene permisos
      hasPermissions() {
        if (!popupManager) return false;
        return popupManager.tienePermisosNotificacion;
      },

      // Probar notificación
      test() {
        if (!popupManager) {
          console.warn('⚠️ Sistema de notificaciones no inicializado.');
          return null;
        }
        
        return popupManager.probarNotificacion();
      },

      // Acceso directo al popup manager
      get manager() {
        return popupManager;
      },

      // Notificaciones predefinidas para diferentes tipos de alertas
      alert: {
        // Alerta crítica
        critical(mensaje, ubicacion = '') {
          const titulo = '🚨 EnerHVAC - Alerta Crítica';
          const body = ubicacion ? `📍 ${ubicacion}\n⚠️ ${mensaje}` : `⚠️ ${mensaje}`;
          
          return Vue.prototype.$notifications.show(titulo, {
            body,
            tag: 'critical-alert',
            requireInteraction: true,
            icon: '/images/logo.png',
            onClick: () => {
              // Opcional: navegar a la sección de alertas
              console.log('Usuario hizo clic en alerta crítica');
            }
          });
        },

        // Alerta de advertencia
        warning(mensaje, ubicacion = '') {
          const titulo = '⚠️ EnerHVAC - Advertencia';
          const body = ubicacion ? `📍 ${ubicacion}\n${mensaje}` : mensaje;
          
          return Vue.prototype.$notifications.show(titulo, {
            body,
            tag: 'warning-alert',
            icon: '/images/logo.png'
          });
        },

        // Información general
        info(mensaje, ubicacion = '') {
          const titulo = 'ℹ️ EnerHVAC - Información';
          const body = ubicacion ? `📍 ${ubicacion}\n${mensaje}` : mensaje;
          
          return Vue.prototype.$notifications.show(titulo, {
            body,
            tag: 'info-alert',
            icon: '/images/logo.png'
          });
        },

        // Alerta de mantenimiento
        maintenance(mensaje, ubicacion = '') {
          const titulo = '🔧 EnerHVAC - Mantenimiento';
          const body = ubicacion ? `📍 ${ubicacion}\n🔧 ${mensaje}` : `🔧 ${mensaje}`;
          
          return Vue.prototype.$notifications.show(titulo, {
            body,
            tag: 'maintenance-alert',
            icon: '/images/logo.png'
          });
        },

        // Alerta de energía
        energy(mensaje, ubicacion = '') {
          const titulo = '⚡ EnerHVAC - Consumo Energético';
          const body = ubicacion ? `📍 ${ubicacion}\n⚡ ${mensaje}` : `⚡ ${mensaje}`;
          
          return Vue.prototype.$notifications.show(titulo, {
            body,
            tag: 'energy-alert',
            icon: '/images/logo.png'
          });
        }
      }
    };

    // Método global para acceso rápido
    Vue.prototype.$notify = Vue.prototype.$notifications.show;
  }
};

export default NotificationsPlugin;